import { Component, Event, EventEmitter, Host, Method, Prop, h } from '@stencil/core';
import { v4 as uuidv4 } from 'uuid';

@Component({
  tag: 'anchor-help-box',
  styleUrl: 'help-box.scss',
  shadow: true,
})
export class HelpBox {
  /**
   *  Give this instance of help-box a custom ID, or keep the default.
   */
  @Prop({}) uuid: string = uuidv4();

  /**
   * to close the help box if needed 
   */
  @Prop({ mutable: true }) canClose: boolean = false;

  /**
   * arialabel for close button icon in banner- used for accessibility
   */
  @Prop({ reflect: true, mutable: true }) closeButtonAriaLabel: string;

  /**
   * title for close button icon
   */
  @Prop({ reflect: true, mutable: true }) closeButtonTitle: string;

  /**
   * Event emitted when the close icon is clicked.
   */
  @Event() closed: EventEmitter<void>;
  
  /**
   * Handles the click event of the close icon.
   */
  @Method()
  async close() {
    this.closed.emit();
  }

  render() {
    return (
      <Host>
        <div id={this.uuid} class={`anchor-c-help-box`}>
          <div class="anchor-c-help-box__content">
            <slot name="icon"></slot>
            <slot name="header"></slot>
            <slot></slot>
            <slot name="link"></slot>
          </div>
          {this.canClose && (
            <anchor-icon-button class="anchor-c-help-box__close-icon" buttonTitle={this.closeButtonTitle} onClick={() => this.close()} aria-label={this.closeButtonAriaLabel}>
              <anchor-icon slot="icon" name="x" size="small"></anchor-icon>
            </anchor-icon-button>
          )}
        </div>
      </Host>
    );
  }
}
